import { render } from "./HolidaySchedule.vue?vue&type=template&id=24ff88bd&scoped=true"
import script from "./HolidaySchedule.vue?vue&type=script&lang=js"
export * from "./HolidaySchedule.vue?vue&type=script&lang=js"

import "./HolidaySchedule.vue?vue&type=style&index=0&id=24ff88bd&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ff88bd"]])

export default __exports__